
export default function TempiRisposta() {
  const steps = [
    {
      number: '1',
      title: 'Contatto',
      description: 'Ricevi la nostra risposta entro 2 ore lavorative'
    },
    {
      number: '2',
      title: 'Briefing',
      description: 'Call conoscitiva di 15 minuti per capire le tue esigenze'
    },
    {
      number: '3',
      title: 'Pre-Analisi',
      description: 'Consegna del report preliminare entro 48 ore'
    },
    {
      number: '4',
      title: 'Presentazione',
      description: 'Meeting per discutere risultati e prossimi passi'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Tempi di Risposta Garantiti
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Il nostro processo è studiato per offrirti risposte rapide e concrete.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {steps.map((step, index) => (
            <div
              key={index}
              className="text-center"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#E879F9] text-white text-2xl font-bold rounded-full mx-auto mb-4">
                {step.number}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {step.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#0B1F3B] to-blue-900 rounded-2xl p-8 text-center">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
              Servizio Clienti Dedicato
            </h3>
            <p className="text-blue-100 text-lg mb-6">
              Un consulente dedicato ti seguirà in ogni fase del processo, garantendo massima professionalità e trasparenza.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <div className="flex items-center text-white">
                <i className="ri-time-line text-[#E879F9] mr-2"></i>
                <span>Risposta in 2 ore</span>
              </div>
              <div className="flex items-center text-white">
                <i className="ri-user-star-line text-green-500 mr-2"></i>
                <span>Consulente dedicato</span>
              </div>
              <div className="flex items-center text-white">
                <i className="ri-shield-check-line text-[#E879F9] mr-2"></i>
                <span>Servizio garantito</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
